import { Component, OnInit, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { Platform, Events, AlertController, NavController, ModalController, ActionSheetController, PopoverController, IonRouterOutlet } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { JPush } from '@jiguang-ionic/jpush/ngx';
import { Device } from "@ionic-native/device/ngx";
import { TranslateService } from "@ngx-translate/core";
import { APPConfig } from './config/env';
import { LocalStorageService, AppService, DataService, PopDataService, ContractorDataService, CustomizedInspectionDataService,
  DocumentDataService, ExamDataService, GovDataService, HiddenDataService, ImmediateFindingDataService, IncidentPopDataService,
  LanguageService,
 } from './service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
// import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Subscription } from 'rxjs';
import { Toast } from '@ionic-native/toast/ngx';
import { Keyboard } from '@ionic-native/keyboard';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '../environments/environment';  // Ensure this is imported

import { PrivacyDialogComponent } from './shared/components/privacy-dialog/privacy-dialog.component';
import { BusinessRegion } from './shared/models/business-region.model';
declare var $: any;

const FALLBACK_LANG = 'en_US';
const APP_LANGS = ['zh_CN', 'zh_TW', 'en_US', 'vi', 'km', 'th', 'lo'];
const LANG_PATTERN = /zh_CN|zh_TW|en_US|vi|km|th|lo/i;
// 语言包再慢也不能让首屏一直空着，超时后照常导航（此时多半会先显示 key，但页面是活的）
const I18N_READY_TIMEOUT = 8000;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
  public registrationId: string;
  devicePlatform: string;
  sequence: number = 0;
  private backbuttonSubscription: Subscription;
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  swipeEnable = true;
  // i18n 就绪信号：所有导航（含首次导航）都必须等它 resolve，否则页面会渲染出 key。
  // 它只会 resolve、不会 reject —— 语言包加载失败时退回英文，最坏情况也要放行导航。
  private translationsReady: Promise<void>;
  private initialNavigationStarted = false;
  userInfo = JSON.parse(this.localStorageService.getStore('userInfo'));
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private jPush: JPush,
    private device: Device,
    public translateService: TranslateService,
    private events: Events,
    public localStorageService: LocalStorageService,
    public router: Router,
    public popDataService: PopDataService,
    // public  appVersion:AppVersion,
    public inAppBrowser: InAppBrowser,
    public alertController: AlertController,
    public appService: AppService,
    public dataService: DataService,
    public navController: NavController,
    private modalCtrl: ModalController,
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private toast: Toast,
    public navCtrl: NavController,
    public activatedRoute: ActivatedRoute,
    private swUpdate: SwUpdate,
    private contractorDataService: ContractorDataService,
    private customizedInspectionDataService: CustomizedInspectionDataService,
    private documentDataService: DocumentDataService,
    private examDataService: ExamDataService,
    private govDataService: GovDataService,
    private hiddenDataService: HiddenDataService,
    private immediateFindingDataService: ImmediateFindingDataService,
    private incidentPopDataService: IncidentPopDataService,
    private languageService: LanguageService,
    // @HostListener('document:ionBackButton', ['$event']);
    // private overrideHardwareBackAction($event: any) {
    //     $event.detail.register(100, async () => {
    //      // Do what you want
    //     });
    // }  

  ) {
    this.devicePlatform = this.device.platform;
    this.captureInitialDeepLink();
    this.translationsReady = this.initializeTranslate();
    this.translationsReady.then(() => this.startInitialNavigation());
    this.initializeApp();
    this.initConfig();
    // this.initjPush();
    this.backButtonEvent();

    // 监听当前页面的是否需要禁止返回
    this.dataService.returnSwipeObservable.subscribe(res => {
      this.swipeEnable = res;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // 1. IGNORE THE LOGIN PAGE
        // If the URL contains 'login', stop immediately.
        if (
          this.router.url.includes('/login') ||
          this.router.url.includes('/contractor-login') ||
          this.router.url.includes('/gateway-indexing') ||
          this.router.url.includes('/app-login') ||
          this.router.url.includes('/auto-login') ||
          this.router.url.includes('fromAutoLogin=true')
        ) {
          return;
        }

        // 2. CHECK THE SESSION FLAG
        const hasShownPrivacy = this.localStorageService.getStore('isPrivacy');
        if (hasShownPrivacy === 'true') {
          return;
        }

        const privacyPopInfo = JSON.parse(localStorage.getItem('_SYS_BR_pop'));
        const areas = localStorage.getItem('areas') || '';
        
        const applicableRegions: BusinessRegion[] = [];
        
        // 1. Automatically get all values from the enum
        const regions = Object.values(BusinessRegion);

        const isContractor = localStorage.getItem('partyEmployee') === 'true';
        const userAreas = areas || '';

        // 2. Iterate through every region defined in the enum
        regions.forEach((regionId: BusinessRegion) => {
          if (userAreas.includes(regionId)) {
            // Dynamically generate the key name
            const popKey = `${regionId}_pop`;
            const status = privacyPopInfo[popKey];

            // Logic logic: '1'=Everyone, '2'=Contractors, '3'=Employees
            const isEnabled =
              status === '1' ||
              (isContractor && status === '2') ||
              (!isContractor && status === '3');

            if (isEnabled) {
              applicableRegions.push(regionId);
            }
          }
        });
        if (applicableRegions.length) {
          this.showPrivacyDialog(applicableRegions);
        }
      }
    })
  }

  ngOnInit() {
    // const event = fromEvent(document, 'backbutton');
    // this.backbuttonSubscription = event.subscribe(async () => {
    //     const modal = await this.modalCtrl.getTop();
    //     if (modal) {
    //       alert('1');
    //       modal.dismiss();
    //     }
    // });
    // event.subscribe(async() => {
    //   alert('1');
    // });
    // this.platform.backButton.subscribe(() => {
    //   //代码当用户按下后退按钮时执行
    //   alert('1');
    //  });
    // this.setupPWA();
    if (this.platform.is('ios')) {
      let
        appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
        appElHeight = appEl.clientHeight;

      Keyboard.disableScroll(true);

      window.addEventListener('native.keyboardshow', (e) => {
        appEl.style.height = (appElHeight - (<any>e).keyboardHeight) + 'px';
      });

      window.addEventListener('native.keyboardhide', () => {
        appEl.style.height = '100%';
      });
    }

  }
  async showPrivacyDialog(markets: BusinessRegion[]) {
    const popover = await this.popoverCtrl.create({
      component: PrivacyDialogComponent,
      componentProps: {
        markets: markets
      },
      showBackdrop: true,
      backdropDismiss: false,
    });
    popover.onDidDismiss().then((res) => {
      if (res) {
        this.localStorageService.setStore('isPrivacy', true);
      }
    });
    return await popover.present();
  }
  ngAfterViewInit() {
    // This element never changes.
    let ionapp = document.getElementsByTagName("ion-app")[0];

    window.addEventListener('keyboardDidShow', async (event) => {
      // Move ion-app up, to give room for keyboard
      let kbHeight: number = event["keyboardHeight"];
      let viewportHeight: number = $(window).height();
      let inputFieldOffsetFromBottomViewPort: number = viewportHeight - $(':focus')[0].getBoundingClientRect().bottom;
      let inputScrollPixels = kbHeight - inputFieldOffsetFromBottomViewPort;

      // Set margin to give space for native keyboard.
      ionapp.style["margin-bottom"] = kbHeight.toString() + "px";

      // But this diminishes ion-content and may hide the input field...
      if (inputScrollPixels > 0) {
        // ...so, get the ionScroll element from ion-content and scroll correspondingly
        // The current ion-content element is always the last. If there are tabs or other hidden ion-content elements, they will go above.
        let ionScroll = await $("ion-content").last()[0].getScrollElement();
        setTimeout(() => {
          $(ionScroll).animate({
            scrollTop: ionScroll.scrollTop + inputScrollPixels
          }, 300);
        }, 300); // Matches scroll animation from css.
      }
    });
    window.addEventListener('keyboardDidHide', () => {
      // Move ion-app down again
      // Scroll not necessary.
      ionapp.style["margin-bottom"] = "0px";
    });



  }

  setupPWA() {
    if (environment.production) {
      // Register the service worker dynamically for production
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('ngsw-worker.js').then(registration => {
          console.log('Service Worker registered with scope: ', registration.scope);
        }).catch(err => {
          console.log('Service Worker registration failed: ', err);
        });
      }
    }
  }

  checkUpdate() {
    var platTxt = "ios_app_version";
    let versionNo = APPConfig.IOS_VERSION;
    this.devicePlatform = this.device.platform;
    if (!this.devicePlatform && this.platform.is('android')) {
      this.devicePlatform = "Android";
    }
    if (this.devicePlatform == "Android") {
      platTxt = "android_app_version";
      versionNo = APPConfig.ANDROID_VERSION;
    }
    this.localStorageService.setStore("APP_VERSION", versionNo);
    this.dataService.checkVersion(platTxt).subscribe(res => {
      if (res && res.STATUS == "0") {
        let lastVersion = res.DATA.value;
        let updateURL = res.DATA.description;
        // this.appVersion.getVersionNumber().then((versionNo: string) => {
        // this.localStorageService.setStore("APP_VERSION",versionNo);
        //   if(versionNo<lastVersion){
        //     this.openUrlByBrowser(updateURL);
        //   }
        // });
        if (versionNo < lastVersion) {
          this.showUpdate(updateURL);
        }
      }
    }, (err) => {
      this.appService.toastTip("shared_components.common.get_data_failed", true);
    });
  }
  openUrlByBrowser(url: string) {
    this.inAppBrowser.create(url, '_system');
  }
  isMobile(): boolean {
    return this.platform.is('mobile') && !this.platform.is('mobileweb');
  }
  async showUpdate(url) {
    const confirm = await this.alertController.create({
      header: this.translateService.instant('APP_UPDATE.firmware_update'),
      message: this.translateService.instant('APP_UPDATE.firmware_update_msg'),
      buttons: [
        {
          text: this.translateService.instant('common.no'),
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: this.translateService.instant('common.yes'),
          handler: () => {
            this.openUrlByBrowser(url);
          }
        }
      ]
    });
    await confirm.present();
  }
  // 解析形如 /contractor-work/approval?taskId=608&pending=false 的完整路径，
  // 按 query string 自行解析 queryParams 后再 navigate，不依赖 getCurrentNavigation()
  // （platform.ready() 回调触发时当前导航基本已结束，取到的是 null）。
  handleRegularUrl(url: string) {
    const urlData = url.split('?');
    const queryParams = {};
    if (urlData[1]) {
      urlData[1].split('&').forEach(item => {
        const [key, value] = item.split('=');
        if (key) {
          queryParams[key] = decodeURIComponent(value || '');
        }
      });
    }
    this.router.navigate([urlData[0]], { queryParams });
  }

  // 企微等外部渠道通过深链直接打开App时（形如 #/contractor-work/approval?taskId=xxx&pending=false），
  // 记录下这个初始地址到 REDIRECT，避免 initializeApp() 里"无 REDIRECT 则强制跳转首页"的逻辑
  // 把已登录用户直接带进来的深链覆盖掉。
  private captureInitialDeepLink(): void {
    if (this.localStorageService.getStore('REDIRECT')) {
      return;
    }
    const hash = window.location.hash || '';
    const initialPath = hash.indexOf('#') === 0 ? hash.substring(1) : hash;
    const isBlankEntry =
      !initialPath ||
      initialPath === '/' ||
      initialPath.indexOf('/tabs/home') !== -1 ||
      initialPath.indexOf('/login') !== -1 ||
      initialPath.indexOf('/contractor-login') !== -1 ||
      initialPath.indexOf('/app-login') !== -1 ||
      initialPath.indexOf('/gateway-indexing') !== -1 ||
      initialPath.indexOf('/auto-login') !== -1 ||
      initialPath.indexOf('fromAutoLogin=true') !== -1;
    if (!isBlankEntry) {
      this.localStorageService.setStore('REDIRECT', initialPath);
    }
  }

  initializeApp() {
    // 这里同样要等 i18n：platform.ready() 可能早于语言包加载完成，
    // 若抢先 handleRegularUrl() 导航，深链页面依旧会拿不到翻译。
    this.platform.ready().then(() => this.translationsReady).then(() => {
      var token = this.localStorageService.getStore("token");
      const REDIRECT = this.localStorageService.getStore('REDIRECT');
      const a = window.location.href.toString();
      // alert('href: ' + a);
      // alert('token: ' + token);
      // alert('REDIRECT: ' + REDIRECT);
      //清空一下所有缓存文件里面的数据
      this.clearAllServiceData();
      this.loadPersonalizedConfiguration();

      if (window.location.href.indexOf('fromAutoLogin=true') !== -1 || 
      window.location.href.indexOf('auto-issue-reporting') !== -1 || 
      window.location.href.indexOf('auto-immediate-inspection') !== -1 || 
      window.location.href.indexOf('auto-immediate-observation') !== -1
    ) {
        return;
      }
      if (token) {
        if (REDIRECT) {
          this.localStorageService.removeStore('REDIRECT');
          this.handleRegularUrl(REDIRECT);
        } else {
          this.navController.navigateRoot(['/tabs/home']);
        }
        // this.router.navigateByUrl('/task-detail');
        // this.router.navigateByUrl('/tabs/home');
        // this.router.navigate(['/tabs/home']);
      }
      var fontSize = this.localStorageService.getStore("APP_FONT_SIZE");
      if (fontSize) {
        this.appService.setGlobalFontSize(fontSize);
      }
      // this.statusBar.styleDefault();
      // this.statusBar.backgroundColorByHexString('#ffffff');
      this.splashScreen.hide();
    });

    // 监听安卓返回按钮
    // const event = fromEvent(document, 'backbutton');
    // event.subscribe(async () => {
    //   alert('1111');
    // });
  }
  // 加载接口主题配置并缓存衍生颜色。
  private loadPersonalizedConfiguration() {
    this.dataService.getPersonalizedConfigurationPublic().subscribe((res: any) => {
      const themeColor =
        res && res.DATA && typeof res.DATA.themeColor === 'string'
          ? res.DATA.themeColor.trim()
          : '';
      const hasThemeColor = /^#[0-9a-fA-F]{6}$/.test(themeColor);
      const secondaryThemeColor =
        res && res.DATA && typeof res.DATA.secondaryThemeColor === 'string'
          ? res.DATA.secondaryThemeColor.trim()
          : '';
      const hasSecondaryThemeColor = /^#[0-9a-fA-F]{6}$/.test(secondaryThemeColor);
      const profileBackground =
        res && res.DATA && res.DATA.profileBackground
          ? res.DATA.profileBackground
          : {};
      const backgroundPath =
        typeof profileBackground.path === 'string'
          ? profileBackground.path.trim()
          : '';
      const backgroundType =
        typeof profileBackground.type === 'string'
          ? profileBackground.type.trim()
          : '';
      const backgroundName =
        typeof profileBackground.name === 'string'
          ? profileBackground.name.trim()
          : '';
      const backgroundSource = backgroundType || backgroundName || backgroundPath;
      const isSvgBackground =
        /\.svg(?:[?#].*)?$/i.test(backgroundSource) ||
        /image\/svg\+xml/i.test(backgroundSource);
      const browserFavicon =
        res && res.DATA && res.DATA.browserFavicon ? res.DATA.browserFavicon : {};
      const browserFaviconPath =
        typeof browserFavicon.path === 'string' ? browserFavicon.path.trim() : '';
      const hasBrowserFavicon = /^(https?:\/\/|\/|assets\/)/.test(browserFaviconPath);

      if (hasBrowserFavicon) {
        this.applyBrowserFavicon(browserFaviconPath);
      }

      if (hasThemeColor) {
        this.applyThemeColor(themeColor);
      }

      if (hasSecondaryThemeColor) {
        this.applySecondaryThemeColor(secondaryThemeColor);
      }

      if (hasSecondaryThemeColor) {
        document.documentElement.style.setProperty(
          '--swire-theme-color-secondary',
          secondaryThemeColor
        );
        document.documentElement.style.setProperty(
          '--swire-theme-color-secondary-rgb',
          this.hexToRgb(secondaryThemeColor)
        );
      }

      if (backgroundPath) {
        document.documentElement.style.setProperty(
          '--swire-profile-background',
          `url("${backgroundPath}")`
        );
        document.documentElement.style.setProperty(
          '--swire-profile-background-size',
          isSvgBackground ? 'cover' : '100% 100%'
        );
      }

      if (hasThemeColor || hasSecondaryThemeColor || backgroundPath || hasBrowserFavicon) {
        try {
          const cachedTheme = window.localStorage.getItem('SWIRE_THEME_CONFIG');
          const themeConfig = cachedTheme ? JSON.parse(cachedTheme) : {};

          if (hasThemeColor) {
            themeConfig.themeColor = themeColor;
            themeConfig.themeColorRgb = this.hexToRgb(themeColor);
            themeConfig.themeColorDark = this.darkenHex(themeColor, 0.18);
            themeConfig.themeColorLight = this.lightenHex(themeColor, 0.35);
            themeConfig.themeColorActive = this.deriveActiveHex(themeColor);
          }
          if (hasSecondaryThemeColor) {
            themeConfig.secondaryThemeColor = secondaryThemeColor;
            themeConfig.secondaryThemeColorRgb = this.hexToRgb(secondaryThemeColor);
          }
          if (backgroundPath) {
            themeConfig.profileBackgroundPath = backgroundPath;
            themeConfig.profileBackgroundType = backgroundType || backgroundName;
          }
          if (hasBrowserFavicon) {
            themeConfig.browserFaviconPath = browserFaviconPath;
          }

          window.localStorage.setItem(
            'SWIRE_THEME_CONFIG',
            JSON.stringify(themeConfig)
          );
        } catch (error) {
        }
      }
    });
  }

  private applyBrowserFavicon(faviconPath: string): void {
    let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconPath;
    link.type = /\.svg(?:[?#].*)?$/i.test(faviconPath) ? 'image/svg+xml' : 'image/png';
  }

  // 旧默认值：主色 #CD0720、暗色 #A8051A、亮色 #DF5E6E、active #FF2D2D。
  // 当前主题：主色/RGB同步替换，暗色按18%、亮色按35%派生，active按HSL参考关系派生。
  private applyThemeColor(themeColor: string): void {
    document.documentElement.style.setProperty(
      '--swire-theme-color',
      themeColor
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-rgb',
      this.hexToRgb(themeColor)
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-dark',
      this.darkenHex(themeColor, 0.18)
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-light',
      this.lightenHex(themeColor, 0.35)
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-active',
      this.deriveActiveHex(themeColor)
    );
    
  }
  //第二主题
   private applySecondaryThemeColor(secondaryThemeColor: string): void {
    document.documentElement.style.setProperty(
      '--swire-theme-color-secondary',
      secondaryThemeColor
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-secondary-rgb',
      this.hexToRgb(secondaryThemeColor)
    );
    document.documentElement.style.setProperty(
      '--swire-theme-color-secondary-dark',
      this.darkenHex(secondaryThemeColor, 0.18)
    );
  }
  // 将十六进制主题色转换为 RGB 通道值。
  private hexToRgb(hexColor: string): string {
    const hex = hexColor.substring(1);
    return `${parseInt(hex.substring(0, 2), 16)}, ${parseInt(hex.substring(2, 4), 16)}, ${parseInt(hex.substring(4, 6), 16)}`;
  }

  // 按比例计算主题暗色。
  private darkenHex(hexColor: string, amount: number): string {
    const hex = hexColor.substring(1);
    const darkenChannel = (startIndex: number): string => {
      const channel = Math.max(
        0,
        Math.min(255, Math.round(parseInt(hex.substring(startIndex, startIndex + 2), 16) * (1 - amount)))
      );
      const channelHex = channel.toString(16);
      return channelHex.length === 1 ? `0${channelHex}` : channelHex;
    };

    return `#${darkenChannel(0)}${darkenChannel(2)}${darkenChannel(4)}`;
  }

  // 按比例计算主题亮色。
  private lightenHex(hexColor: string, amount: number): string {
    const hex = hexColor.substring(1);
    const lightenChannel = (startIndex: number): string => {
      const channel = parseInt(hex.substring(startIndex, startIndex + 2), 16);
      const lightenedChannel = Math.min(
        255,
        Math.round(channel + (255 - channel) * amount)
      );
      const channelHex = lightenedChannel.toString(16);
      return channelHex.length === 1 ? `0${channelHex}` : channelHex;
    };

    return `#${lightenChannel(0)}${lightenChannel(2)}${lightenChannel(4)}`;
  }

  // 按 #CD0720 -> #FF2D2D 的 HSL 关系计算当前主题的 active 色。
  private deriveActiveHex(hexColor: string): string {
    const referenceTheme = this.hexToHsl('#CD0720');
    const referenceActive = this.hexToHsl('#FF2D2D');
    const currentTheme = this.hexToHsl(hexColor);
    const hueShift = referenceActive.h - referenceTheme.h;
    const saturationScale = referenceTheme.s === 0
      ? 1
      : referenceActive.s / referenceTheme.s;
    const lightnessDelta = referenceActive.l - referenceTheme.l;

    return this.hslToHex(
      currentTheme.h + hueShift,
      Math.min(100, currentTheme.s * saturationScale),
      Math.max(0, Math.min(100, currentTheme.l + lightnessDelta))
    );
  }

  // 将十六进制颜色转换为 HSL。
  private hexToHsl(hexColor: string): { h: number; s: number; l: number } {
    const hex = hexColor.substring(1);
    const red = parseInt(hex.substring(0, 2), 16) / 255;
    const green = parseInt(hex.substring(2, 4), 16) / 255;
    const blue = parseInt(hex.substring(4, 6), 16) / 255;
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const delta = max - min;
    const lightness = (max + min) / 2;
    let hue = 0;
    let saturation = 0;

    if (delta !== 0) {
      saturation = lightness > 0.5
        ? delta / (2 - max - min)
        : delta / (max + min);

      switch (max) {
        case red:
          hue = (green - blue) / delta + (green < blue ? 6 : 0);
          break;
        case green:
          hue = (blue - red) / delta + 2;
          break;
        default:
          hue = (red - green) / delta + 4;
          break;
      }

      hue /= 6;
    }

    return {
      h: hue * 360,
      s: saturation * 100,
      l: lightness * 100,
    };
  }

  // 将 HSL 颜色转换为十六进制。
  private hslToHex(hue: number, saturation: number, lightness: number): string {
    const normalizedHue = ((hue % 360) + 360) % 360 / 360;
    const normalizedSaturation = saturation / 100;
    const normalizedLightness = lightness / 100;
    let red = normalizedLightness;
    let green = normalizedLightness;
    let blue = normalizedLightness;

    if (normalizedSaturation !== 0) {
      const q = normalizedLightness < 0.5
        ? normalizedLightness * (1 + normalizedSaturation)
        : normalizedLightness + normalizedSaturation - normalizedLightness * normalizedSaturation;
      const p = 2 * normalizedLightness - q;
      const hueToRgb = (t: number): number => {
        let channel = t;
        if (channel < 0) { channel += 1; }
        if (channel > 1) { channel -= 1; }
        if (channel < 1 / 6) { return p + (q - p) * 6 * channel; }
        if (channel < 1 / 2) { return q; }
        if (channel < 2 / 3) { return p + (q - p) * (2 / 3 - channel) * 6; }
        return p;
      };

      red = hueToRgb(normalizedHue + 1 / 3);
      green = hueToRgb(normalizedHue);
      blue = hueToRgb(normalizedHue - 1 / 3);
    }

    const toHex = (channel: number): string => {
      const value = Math.round(channel * 255).toString(16);
      return value.length === 1 ? `0${value}` : value;
    };

    return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
  }

  initConfig() {
    var API_DOMAIN = this.localStorageService.getStore('API_DOMAIN');
    // 历史上 AppService.logout() 曾在 API_DOMAIN 缺失时把 null 存成字符串 "null"，
    // 这里一并当作"未配置"处理，避免因为这个坏值而一直不修复。
    if (!API_DOMAIN || API_DOMAIN === 'null') {
      this.localStorageService.setStore("API_DOMAIN", APPConfig.API_DOMAIN);
      this.localStorageService.setStore("API_DIR", APPConfig.API_DIR);
      this.localStorageService.setStore("UPLOAD_URL", APPConfig.UPLOAD_URL);
      this.dataService.updatePrefix();
    }
    // this.checkUpdate();
  }
  initializeTranslate(): Promise<void> {
    // --- set i18n begin ---  
    // 添加语言支持
    this.translateService.addLangs(APP_LANGS);
    // 设置默认语言，一般无法匹配的时候使用
    var lang = this.localStorageService.getStore("APP_LANG");
    if (!lang) {
      const browserLang = this.translateService.getBrowserLang() || '';
      console.log("browserLang:" + browserLang);
      lang = browserLang.match(LANG_PATTERN) ? browserLang : FALLBACK_LANG;
      this.localStorageService.setStore("APP_LANG", lang);
    }
    this.languageService.setLanguage(lang);
    this.events.subscribe('CHANGE_LANG', (lang) => {
      this.translateService.use(lang);
      this.languageService.setLanguage(lang);
    });
    // --- set i18n end ---
    // 也可以将语言存在缓存中，供切换语言时，其他模块同时读取到语言的变化
    // sessionStorage.setItem("language",'en');
    return this.loadLanguageWithFallback(lang);
  }

  // 先把英文包装载好并设为 defaultLang，再切到目标语言。
  // 这样有两层兜底：目标语言整包加载失败 -> 整体退回英文；
  // 目标语言加载成功但个别 key 缺失 -> ngx-translate 自动回退到 defaultLang 的英文文案，
  // 而不是把 key 原样显示出来。
  private loadLanguageWithFallback(lang: string): Promise<void> {
    const useLang = (target: string): Promise<boolean> =>
      new Promise<boolean>((resolve) => {
        this.translateService.use(target).subscribe(
          () => resolve(true),
          () => resolve(false)
        );
      });

    const ready = useLang(FALLBACK_LANG)
      .then(() => {
        // 此时 en_US 已在 translations 里，setDefaultLang 会同步生效，不会再发一次请求
        this.translateService.setDefaultLang(FALLBACK_LANG);
        if (lang === FALLBACK_LANG) {
          return true;
        }
        return useLang(lang).then((ok) => {
          if (!ok) {
            // 目标语言加载失败：把选择也改回英文，避免下次启动继续卡在坏语言上
            console.warn('i18n: failed to load "' + lang + '", falling back to ' + FALLBACK_LANG);
            this.localStorageService.setStore('APP_LANG', FALLBACK_LANG);
            this.languageService.setLanguage(FALLBACK_LANG);
            return useLang(FALLBACK_LANG);
          }
          return true;
        });
      })
      .then(() => undefined)
      .catch(() => undefined);

    // 最后一道保险：无论语言包发生什么，都不能把首屏卡死在空白页
    const timeout = new Promise<void>((resolve) => {
      setTimeout(() => resolve(), I18N_READY_TIMEOUT);
    });
    return Promise.race([ready, timeout]);
  }

  // 首次导航只能触发一次，重复调用会抛 "Navigation triggered outside Angular zone" 之类的问题
  private startInitialNavigation(): void {
    if (this.initialNavigationStarted) {
      return;
    }
    this.initialNavigationStarted = true;
    this.router.initialNavigation();
  }
  initjPush() {
    this.jPush.init();
    this.jPush.setDebugMode(true);
    this.jPush.resetBadge();
    document.addEventListener(
      "jPush.receiveNotification",
      (event: any) => {
        var content;
        if (this.devicePlatform == "Android") {
          content = event.alert;
        } else {
          content = event.aps.alert;
        }
        this.jPush.setBadge(0);
        alert("Receive notification: " + JSON.stringify(event));
      },
      false
    );

    document.addEventListener(
      "jPush.openNotification",
      (event: any) => {
        var content;
        if (this.devicePlatform == "Android") {
          content = event.alert;
        } else {
          // iOS
          if (event.aps == undefined) {
            // 本地通知
            content = event.content;
          } else {
            // APNS
            content = event.aps.alert;
          }
        }
        this.jPush.setBadge(0);
        alert("open notification: " + JSON.stringify(event));
      },
      false
    );

    document.addEventListener(
      "jPush.receiveLocalNotification",
      (event: any) => {
        // iOS(*,9) Only , iOS(10,*) 将在 jPush.openNotification 和 jPush.receiveNotification 中触发。
        var content;
        if (this.devicePlatform == "Android") {
        } else {
          content = event.content;
        }
        alert("receive local notification: " + JSON.stringify(event));
      },
      false
    );

    this.events.subscribe('SET_JPUSH_ALIAS', (opt) => {
      this.setAlias(opt);
    });
    this.events.subscribe('DELETE_JPUSH_ALIAS', (opt) => {
      this.deleteAlias(opt);
    });
  }
  aliasResultHandler = function (result) {
    var sequence: number = result.sequence;
    var alias: string = result.alias;
    console.log("JPush Alias Success!" + "\nSequence: " + sequence + "\nAlias: " + alias);
  };

  errorHandler = function (err) {
    var sequence: number = err.sequence;
    var code = err.code;
    console.log("JPush Alias Error!" + "\nSequence: " + sequence + "\nCode: " + code);
  };

  setAlias(opt) {
    this.jPush
      .setAlias(opt)
      .then(this.aliasResultHandler)
      .catch(this.errorHandler);
  }
  getRegistrationID() {
    this.jPush.getRegistrationID().then(rId => {
      console.log("=====rId=========:" + rId);
      this.registrationId = rId;
    });
  }

  getAlias() {
    this.jPush
      .getAlias({ sequence: this.sequence++ })
      .then(this.aliasResultHandler)
      .catch(this.errorHandler);
  }

  deleteAlias(opt) {
    this.jPush
      // .deleteAlias({ sequence: this.sequence++ })
      .deleteAlias(opt)
      .then(this.aliasResultHandler)
      .catch(this.errorHandler);
  }

  addLocalNotification() {
    if (this.devicePlatform == "Android") {
      this.jPush.addLocalNotification(0, "Hello JPush", "JPush", 1, 5000);
    } else {
      this.jPush.addLocalNotificationForIOS(5, "Hello JPush", 1, "localNoti1");
    }
  }

  backButtonEvent() {
    // this.platform.ready().then(() => {//获取设备异步
    //     this.platform.backButton.subscribe(() => {
    //       debugger
    //       // this.tabsCanGoBack = this.tabs.outlet.canGoBack();
    //       // this.tabsParentCanGoBack = this.tabs.outlet.parentOutlet.canGoBack();
    //       // this.androidBackButtonHandle();
    //     });
    // })


    this.platform.backButton.subscribe(async () => {
      // close action sheet

      // alert('走了这个函数');
      try {
        const element = await this.actionSheetCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
      }

      // close popover
      try {
        const element = await this.popoverCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
      }

      // close modal
      try {
        const element = await this.modalCtrl.getTop();
        if (element) {
          element.dismiss();
          return;
        }
      } catch (error) {
        console.log(error);

      }

      // close side menua
      // try {
      //     const element = await this.menu.getOpen();
      //     if (element) {
      //         this.menu.close();
      //         return;

      //     }

      // } catch (error) {

      // }

      // this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
      //   if (outlet && outlet.canGoBack()) {
      //     outlet.pop();

      //   } else if (this.router.url == '/tab/home') {
      //     if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
      //       // this.platform.exitApp(); // Exit from app
      //       navigator['app'].exitApp(); // work in ionic 4
      //     } else {
      //       this.toast.show(
      //         `Press back again to exit App.`,
      //         '2000',
      //         'center')
      //         .subscribe(toast => {
      //           // console.log(JSON.stringify(toast));
      //         });
      //       this.lastTimeBackPress = new Date().getTime();
      //     }
      //   }
      // });
    });
  }

  clickGoHome() {
    this.navController.navigateForward(['/tabs/home'], {
      queryParams: {
      }
    });
  }

  clearAllServiceData() {
    // 当创建一个新的service文件时，最好在这边加上clear
    this.popDataService.clear();
    this.contractorDataService.clear();
    this.customizedInspectionDataService.clear();
    this.documentDataService.clear();
    this.examDataService.clear();
    this.govDataService.clear();
    this.hiddenDataService.clear();
    this.immediateFindingDataService.clear();
    this.incidentPopDataService.clear();
  }
}
